import Loadable from 'react-loadable';
import { TLoader } from '../../../components/template';

const DigitalCoach = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-digital-coach"*/ './digital-coach').then(module => module.DigitalCoach),
  loading: TLoader
});

const MyPlan = Loadable({
  loader: () => import(/* webpackChunkName: "dashboard-my-plan"*/ './plan').then(module => module.MyPlan),
  loading: TLoader
});

const MyPlanVM = Loadable({
  loader: () => import(/* webpackChunkName: "dashboard-vm-my-plan"*/ './vm-plan').then(module => module.MyPlanVM),
  loading: TLoader
});

const RoadWidget = Loadable({
  loader: () => import(/* webpackChunkName: "dashboard-road"*/ './road').then(module => module.RoadWidget),
  loading: TLoader
});

const DashboardContent = Loadable({
  loader: () => import(/* webpackChunkName: "dashboard-content"*/ './content').then(module => module.DashboardContent),
  loading: TLoader
});

const DashboardAdverts = Loadable({
  loader: () => import(/* webpackChunkName: "dashboard-adverts"*/ './adverts').then(module => module.DashboardAdverts),
  loading: TLoader
});

const EditorialPanelWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-editorial-panel"*/ './editorial-panel').then(
      module => module.EditorialPanelWidget
    ),
  loading: TLoader
});

const MarketPlaceWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-marketplace"*/ './marketplace').then(module => module.MarketPlaceWidget),
  loading: TLoader
});

const Carousel = Loadable({
  loader: () => import(/* webpackChunkName: "dashboard-carousel"*/ './carousel').then(module => module.Carousel),
  loading: TLoader
});

const PointsWidgetVM = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-vm-points"*/ './vm-points').then(module => module.PointsWidgetVM),
  loading: TLoader
});

const AllOtherGoalsWidgetFF = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-vm-ff-all-other-goals"*/ './future-fit-v2/all-other-goals').then(
      module => module.AllOtherGoalsWidgetFF
    ),
  loading: TLoader
});

const PositivePursuitsWidgetFF = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-vm-ff-positive-pursuits"*/ './future-fit-v2/positive-pursuits').then(
      module => module.PositivePursuitsWidgetFF
    ),
  loading: TLoader
});

const HighPriorityGoalsWidgetFF = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-vm-ff-high-priority-goals"*/ './future-fit-v2/high-priority-goals').then(
      module => module.HighPriorityGoalsWidgetFF
    ),
  loading: TLoader
});

const ScoreWidgetFF = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-vm-ff-score"*/ './future-fit-v2/score').then(module => module.ScoreWidgetFF),
  loading: TLoader
});

const MessagesWidgetFF = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-vm-ff-messages"*/ './future-fit-v2/messages').then(
      module => module.MessagesWidgetFF
    ),
  loading: TLoader
});

const MABFinanceSummary = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-mab-finance-summary"*/ './mab-portfolio/finance-summary').then(
      module => module.MABFinanceSummary
    ),
  loading: TLoader
});

const MABPortfolio = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-mab-portfolio"*/ './mab-portfolio/portfolio').then(
      module => module.MABPortfolio
    ),
  loading: TLoader
});

const FeaturedTools = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-featured-tools"*/ './featured-tools').then(module => module.FeaturedTools),
  loading: TLoader
});

const SplitBlock = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-split-block"*/ './split-block').then(module => module.SplitBlock),
  loading: TLoader
});

const CategoryWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-categories"*/ './categories').then(module => module.CategoryWidget),
  loading: TLoader
});

const DashboardContentRepeater = Loadable({
  loader: () =>
    import(/* webpackChunkName: "dashboard-vm-content-repeater"*/ '../../../widgets/repeater/content-repeater').then(
      module => module.DashboardContentRepeater
    ),
  loading: TLoader
});

const BodyWidget = Loadable({
  loader: () => import(/* webpackChunkName: "dashboard-body"*/ './body').then(module => module.Body),
  loading: TLoader
});

const IntroducerBanner = Loadable({
  loader: () =>
    import(/* webpackChunkName: "introducer-banner"*/ './introducer-banner').then(module => module.IntroducerBanner),
  loading: TLoader
});

export const defaultWidgets = {
  digitalCoach: DigitalCoach,
  myPlan: MyPlan,
  myPlanVM: MyPlanVM,
  road: RoadWidget,
  editorial: EditorialPanelWidget,
  marketplace: MarketPlaceWidget,
  carousel: Carousel,
  content: DashboardContent,
  adverts: DashboardAdverts,
  pointsVM: PointsWidgetVM,
  scoreFF: ScoreWidgetFF,
  messagesFF: MessagesWidgetFF,
  HPGFF: HighPriorityGoalsWidgetFF,
  PPFF: PositivePursuitsWidgetFF,
  AOGFF: AllOtherGoalsWidgetFF,
  MABFinanceSummary: MABFinanceSummary,
  MABPortfolio: MABPortfolio,
  featuredTools: FeaturedTools,
  splitBlock: SplitBlock,
  categories: CategoryWidget,
  repeater: DashboardContentRepeater,
  body: BodyWidget,
  introducerBanner: IntroducerBanner
};
